import { useEffect, useState } from 'react';

import { createMockHolidayById, type THolidayDetail } from '../../mocks';

type TVariables = {
  holidayId: string;
  search: { query: string };
  filter: {
    jobPosition: string[];
    country: string[];
  };
  page: { number: number; limit: number };
};

export const useGetHolidayDetails = ({
  variables,
  skip,
}: {
  skip?: boolean;
  variables: TVariables;
}) => {
  const [data, setData] = useState<THolidayDetail | null>(null);
  const [loading, setLoading] = useState(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing suppression
  useEffect(() => {
    if (skip) {
      return;
    }
    setLoading(true);
    setTimeout(() => {
      const holidayDetail = createMockHolidayById(variables.holidayId);
      if (variables.search.query === 'no-results') {
        setData({
          id: '1',
          date: '2024-01-01',
          name: 'Holyday with no results',
          users: [],
          usersCount: 0,
        });
        setLoading(false);
        return;
      }
      const paginatedData = {
        ...holidayDetail,
        users: holidayDetail.users.slice(
          variables.page.number * variables.page.limit,
          (variables.page.number + 1) * variables.page.limit,
        ),
      };
      setData(paginatedData);
      setLoading(false);
    }, 1000);
  }, [JSON.stringify(variables), skip]);

  return {
    data,
    loading,
    error: false,
    refetch: () => {
      console.log('TODO: implement refetch data');
    },
  };
};
